// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { GroundTruthCounter } from "./GroundTruthCounter.gen";

export interface IGroundTruthCounterOption {
	counter: GroundTruthCounter;

	name: string | undefined;

	model: string | undefined;

	description: string | undefined;

	isDefault: boolean;

	$type?: string | undefined;
}
export class GroundTruthCounterOption {
	constructor(data?: IGroundTruthCounterOption) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	counter: GroundTruthCounter = 0;

	name: string | undefined;

	model: string | undefined;

	description: string | undefined;

	isDefault: boolean = false;

	static $type: string = "CoreApi.Models.GroundTruthCounterOption, ";
	$type?: string | undefined = GroundTruthCounterOption.$type;
}

